export const isHexColor = (color: unknown): color is { hex: string } => {
  if (!color) {
    return false;
  }

  return color && typeof color === 'object' && 'hex' in color;
};
